import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { hasBookingFeedback } from '../utils/bookingFeedback';

const boxStyle = {
  marginTop: '12px',
  padding: '12px',
  background: 'rgba(201,168,76,0.06)',
  border: '1px solid rgba(201,168,76,0.2)',
  borderRadius: '8px',
};

const pendingStyle = {
  marginTop: '12px',
  padding: '10px 12px',
  background: 'rgba(255,255,255,0.03)',
  border: '1px solid rgba(255,255,255,0.08)',
  borderRadius: '8px',
};

const BookingFeedbackSummary = ({ booking, className = '' }) => {
  const { t } = useLanguage();

  if (!booking) return null;

  if (hasBookingFeedback(booking)) {
    const submittedAt = booking.client_feedback_at
      ? new Date(booking.client_feedback_at).toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
      : null;

    return (
      <div className={className} style={boxStyle}>
        <p style={{ color: '#c9a84c', fontSize: '11px', fontWeight: 700, margin: '0 0 8px' }}>
          {t('clientFeedbackLabel')}
        </p>
        <p style={{ color: '#e8e0d0', fontSize: '12px', margin: '0 0 4px' }}>
          {String.fromCodePoint(0x2B50)} {booking.client_operator_rating}/5 · {booking.client_satisfied ? t('satisfiedYes') : t('satisfiedNo')}
        </p>
        {booking.client_suggestion ? (
          <p style={{ color: '#8896a8', fontSize: '11px', margin: '0 0 4px' }}>
            &ldquo;{booking.client_suggestion}&rdquo;
          </p>
        ) : null}
        {submittedAt ? (
          <p style={{ color: '#556070', fontSize: '10px', margin: 0 }}>{submittedAt}</p>
        ) : null}
      </div>
    );
  }

  if (!booking.owner_approved) {
    return (
      <div className={className} style={pendingStyle}>
        <p style={{ color: '#8896a8', fontSize: '10px', margin: 0 }}>{t('feedbackAfterDispatch')}</p>
      </div>
    );
  }

  return (
    <div className={className} style={pendingStyle}>
      <p style={{ color: '#8896a8', fontSize: '10px', margin: 0 }}>{t('awaitingClientFeedback')}</p>
    </div>
  );
};

export default BookingFeedbackSummary;
